import { Icon } from '../Icon/Icon';

interface Props {
  id: string;
  label: string;
  value: string;
  options: React.ReactNode;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  name: string;
  error?: string;
  emptyMessage?: string;
  invalidMessage?: string;
}

function CustomSelect({
  id,
  label,
  value,
  options,
  onChange,
  name,
  error,
  emptyMessage,
  invalidMessage,
}: Props) {
  return (
    <div className={`input-container input-container--select${!error ? '' : ' error'}`}>
      <label className="input-label" htmlFor={id}>
        {label}
      </label>
      <div className="input-wrapper">
        <select
          className="input__field input__field--select"
          autoComplete="off"
          id={id}
          name={name}
          value={value}
          onChange={onChange}
        >
          {options}
        </select>
        <Icon.Chevron className="input-container__icon icon-small" />
      </div>
      {!error ? null : (
        <div className="input-error">
          <span>
            {error === 'empty' ? emptyMessage : error === 'invalid' ? invalidMessage : ''}
          </span>
        </div>
      )}
    </div>
  );
}

export default CustomSelect;
